import React from 'react';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import { lawyerData, images, getWhatsAppUrl } from '../data/mock';
import { useParallaxSimple } from '../hooks/useParallax';

export const HeroSection = () => {
  const parallaxBlur1 = useParallaxSimple(0.12);
  const parallaxBlur2 = useParallaxSimple(0.06);
  const parallaxSheen = useParallaxSimple(0.04);

  const scrollToForm = () => {
    const element = document.querySelector('#analise');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="inicio"
      className="relative lg:min-h-screen overflow-hidden bg-[#f5f1ed]"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={images.heroBackground}
          alt=""
          className="h-full w-full object-cover object-center"
          aria-hidden
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#f5f1ed]/95 via-[#f5f1ed]/88 to-[#f5f1ed]/70 sm:bg-gradient-to-r sm:from-[#f5f1ed]/92 sm:via-[#f5f1ed]/55 sm:to-transparent" />
        <div className="absolute inset-0 hidden sm:block bg-gradient-to-t from-[#f5f1ed]/30 via-transparent to-[#f5f1ed]/40" />
        <div
          className="absolute inset-0 bg-gradient-to-br from-[#d4af37]/5 via-transparent to-transparent pointer-events-none"
          style={parallaxSheen.style}
        />
      </div>

      <div
        className="absolute top-16 right-8 sm:right-16 w-36 h-36 sm:w-64 sm:h-64 bg-[#d4af37]/10 rounded-full blur-3xl pointer-events-none"
        style={parallaxBlur1.style}
        aria-hidden
      />
      <div
        className="absolute bottom-20 left-4 sm:left-10 w-40 h-40 sm:w-72 sm:h-72 bg-[#0f1f3d]/5 rounded-full blur-3xl pointer-events-none"
        style={parallaxBlur2.style}
        aria-hidden
      />

      <div className="relative z-10 mx-auto max-w-7xl px-5 pt-24 sm:px-6 sm:pt-28 lg:px-8 lg:pt-32 pb-0">
        <div className="grid items-end gap-8 sm:gap-8 lg:grid-cols-2 lg:gap-4 lg:min-h-[calc(100vh-8rem)]">
          <div className="flex flex-col justify-center pb-1 sm:pb-6 lg:pb-20 lg:pr-8">
            <h1 className="font-serif text-[1.75rem] leading-[1.15] tracking-tight text-[#0f1f3d] mb-3 sm:mb-4 sm:text-4xl md:text-[2.75rem] lg:text-5xl lg:leading-[1.12] animate-slide-up">
              {lawyerData.tagline}
            </h1>

            <p className="font-serif text-base leading-relaxed text-[#b8962e] mb-4 sm:mb-5 sm:text-xl animate-slide-up-delay">
              {lawyerData.subtagline}
            </p>

            <p className="mb-6 max-w-lg text-sm leading-relaxed text-slate-600 sm:mb-8 sm:text-base animate-slide-up-delay">
              {lawyerData.heroDescription}
            </p>

            <div className="mb-5 flex flex-col gap-3 sm:mb-6 sm:flex-row animate-slide-up-delay-2">
              <Button
                size="lg"
                className="rounded-md bg-[#0f1f3d] px-5 py-5 text-sm font-semibold text-white hover:bg-[#1a2f4d] sm:px-6 sm:py-6 sm:text-base"
                asChild
              >
                <a href={getWhatsAppUrl()} target="_blank" rel="noopener noreferrer">
                  <WhatsAppIcon className="h-5 w-5 shrink-0" />
                  Fale conosco no WhatsApp
                </a>
              </Button>
              <Button
                onClick={scrollToForm}
                variant="outline"
                size="lg"
                className="rounded-md border-2 border-[#b8962e] bg-white/50 px-5 py-5 text-sm font-medium text-[#b8962e] backdrop-blur-sm hover:bg-white/70 sm:px-6 sm:py-6 sm:text-base"
              >
                Agendar análise inicial
              </Button>
            </div>

            <p className="flex items-center gap-2 text-sm text-slate-500">
              <Globe className="h-4 w-4 shrink-0 text-[#b8962e]" />
              {lawyerData.onlineNote}
            </p>
          </div>

          <div className="relative -mx-5 flex items-end justify-center self-end sm:-mx-6 lg:mx-0 lg:-mr-8 lg:justify-end xl:-mr-16">
            <img
              src={images.heroPhoto}
              alt="Advogada em postura profissional"
              className="relative z-10 h-[min(42vh,380px)] w-full max-w-[280px] object-contain object-bottom drop-shadow-[0_20px_40px_rgba(15,31,61,0.12)] sm:h-[min(58vh,580px)] sm:max-w-lg lg:h-[min(88vh,820px)] lg:w-auto lg:max-w-none"
            />
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 z-10 hidden -translate-x-1/2 sm:block">
        <div className="flex h-10 w-6 justify-center rounded-full border-2 border-[#d4af37]/40">
          <div className="mt-2 h-3 w-1.5 animate-bounce rounded-full bg-[#d4af37]/80" />
        </div>
      </div>
    </section>
  );
};
